import React, { useEffect, useRef, useState, useContext } from "react";
import './Update.css';
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import SignatureCanvas from 'react-signature-canvas';
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";
import logo from '../../Assest/LogoSingefin.png'

function Update() {

    const urlGetLinkage = urlApiServer + "Linkages?populate=*"
    const urlPostUploadLinkage = urlApiServer + "upload/"

    const sigCanvas = useRef(null);

    const [idCard, setIdCard] = useState('')
    const [name, setName] = useState('')
    const [surnames, setSurnames] = useState('')
    const [currentPosition, setCurrentPosition] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [birthdayDate, setBirthdayDate] = useState('')
    const [signature, setSignature] = useState('')
    const [data, setData] = useState([]);

    const { infoUser, setInfoUser } = useContext(LoginContext)

    const urlPostLinkage = urlApiServer + "linkingforms/" + infoUser.usuario.documentId

    console.log("usuario documentId desde el frontend:", infoUser.usuario.documentId);

    const urlDeleteUpload = urlApiServer + "upload/files/" + infoUser.firma.id

    console.log("firma documentId desde el frontend:", infoUser.firma.id);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (infoUser.isLoged === false) {
            window.location.href = './Inicio';
        }
    }, [infoUser])

    useEffect(() => {
        if (infoUser.isLoged === true) {
            setName(infoUser.usuario.nombres)
            setSurnames(infoUser.usuario.apellidos)
            setIdCard(infoUser.usuario.cedula_ciudadania)
            setBirthdayDate(infoUser.usuario.fecha_nacimiento)
            setCurrentPosition(infoUser.usuario.cargo_actual)
            setPhone(infoUser.usuario.celular_contacto)
            setEmail(infoUser.usuario.correo)
            // setName(infoUser.)
        }
    }, [infoUser])

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetLinkage, requestOptions)
                    .then(response => response.json())
                    .then(UpdateResponse => {
                        console.log('info del Update: ', UpdateResponse.data);
                        setData(UpdateResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();

    }, [urlGetLinkage]);

    const clearSignature = () => {
        if (sigCanvas.current) {
            sigCanvas.current.clear();
            setSignature(null);
        }
    };

    const saveSignature = () => {
        if (sigCanvas.current && sigCanvas.current.isEmpty()) {
            Swal.fire({
                title: "Error",
                text: "Por favor, dibuja tu firma antes de guardar",
                icon: "error",
                allowOutsideClick: false
            });
        } else {
            const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
            setSignature(signatureData);
            Swal.fire({
                title: "Correcto",
                text: "Se ha guardado correctamente la firma",
                icon: "success",
                allowOutsideClick: false
            });
        }
    };

    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleSurnames(e) {
        setSurnames(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleidCard(e) {
        setIdCard(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleBirthdayDate(e) {
        setBirthdayDate(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function headleCurrentPosition(e) {
        setCurrentPosition(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    async function postFormUpdate() {

        if (!signature) {
            Swal.fire({
                title: "Error",
                text: "Porfavor, no olvides poner tu firma",
                icon: "error",
                allowOutsideClick: false
            });
            return;
        }

        const deleteImage = await fetch(urlDeleteUpload, {
            method: 'DELETE',  // Método DELETE para eliminar el recurso
            headers: {
                'Content-Type': 'application/json',  // Tipo de contenido JSON
            },
        })

        if (deleteImage.ok) {
            const data = await deleteImage.json();  // Si la respuesta es exitosa, obtener la respuesta en formato JSON
            console.log('Elemento eliminado:', data);
            const byteString = atob(signature.split(',')[1]);  // Remove "data:image/png;base64,"
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const uintArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                uintArray[i] = byteString.charCodeAt(i);
            }

            const file = new Blob([arrayBuffer], { type: 'image/png' });

            const fileData = new FormData();
            fileData.append('files', file, name + surnames + '.png'); // 'signature.png' is the name for the file

            const requestOptionsFile = {
                method: 'POST',
                body: fileData,
                redirect: 'follow',
            };

            try {
                const responseFile = await fetch(urlPostUploadLinkage, requestOptionsFile);
                const dataPostUploadResponse = await responseFile.json();
                console.log('The image has been uploaded:', dataPostUploadResponse);
                const dataPut = JSON.stringify({
                    data: {
                        nombres: name,
                        apellidos: surnames,
                        cedula_ciudadania: idCard,
                        fecha_nacimiento: birthdayDate,
                        empresa_actual: infoUser.empresa_actual,
                        cargo_actual: currentPosition,
                        ciudad: infoUser.ciudad,
                        departamento: infoUser.departamento,
                        celular_contacto: phone,
                        correo: email,
                        fuiste_referido: infoUser.fuiste_referido,
                        nombre_referido: infoUser.nombre_referido,
                        fecha_afiliacion: infoUser.fecha_afiliacion,
                        firma: name + surnames + '.png' // Here, use the image filename or the URL returned after uploading
                    }
                });

                const registerHeaders = new Headers();
                registerHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: 'PUT',
                    headers: registerHeaders,
                    body: dataPut,
                    redirect: 'follow'
                };

                try {
                    const response = await fetch(urlPostLinkage, requestOptions);
                    const dataPostResponse = await response.json();
                    console.log('Respuesta al actualizar los datos:', dataPostResponse);
                    Swal.fire({
                        title: "Correcto",
                        text: "Se ha actualizado correctamente los datos, vuelve a iniciar sesion",
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: "Entendido"
                    }).then(() => {
                        setInfoUser({
                            isLoged: false,
                            usuario: "unknow",
                            firma: "unknow",
                        })
                        window.location.href = './Inicio';
                    });
                } catch (error) {
                    console.error('Error en la solicitud de actualización:', error);
                    Swal.fire({
                        title: "Error",
                        text: "Ocurrio un problema con la actualizacion de los datos",
                        icon: "error",
                        allowOutsideClick: false
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "Ocurrio un problema con la firma", error,
                    icon: "error",
                    allowOutsideClick: false
                });
            }
        } else {
            Swal.fire({
                title: "Error",
                text: "Ocurrio un problema con la firma",
                icon: "error",
                allowOutsideClick: false
            });
        }

    }

    return (
        <div className="containerUpdateSection">
            <div className="containerBannerUpdate">
                <div className="bannerUpdate">
                    <div
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_vinculacion?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_vinculacion.url})`
                                : "url('../../Assest/temporary/bannerHome.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                        className="imageBannerUpdate"
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerPQRS">
                                {data.length > 0 && data[0].titulo_portada_actualizacion ? data[0].titulo_portada_actualizacion : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                </div>
            </div>
            <div className="containerInfoUpdateSection">
                {data.length > 0 && data[0].texto_seccion_actualizacion ? (
                    data[0].texto_seccion_actualizacion.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoLegalSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoUpdateSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoUpdateSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoUpdateSection">...</p>
                )}
            </div>
            <div className="containerFormUpdateSection">
                <div className="cardFormnUpdateSection">
                    <div className="containerInputsUpdateSection">
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsUpdateSection"
                        />
                        <input
                            type="text"
                            name="surnames"
                            placeholder="Apellidos"
                            value={surnames}
                            onChange={headleSurnames}
                            className="inputsUpdateSection"
                        />
                    </div>
                    <div className="containerInputsUpdateSection">
                        <div className="">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha de nacimiento:
                            </p>
                            <input
                                type="date"
                                name="birthdayDate"
                                placeholder="Fecha de cumpleaños"
                                value={birthdayDate}
                                onChange={headleBirthdayDate}
                                className="inputsUpdateSection"
                            />
                        </div>
                        <input
                            type="number"
                            name="idCard"
                            placeholder="cedula"
                            value={idCard}
                            onChange={headleidCard}
                            className="inputsUpdateSection"
                        />
                    </div>
                    <div className="containerInputsUpdateSection">
                        <input
                            type="text"
                            name="currentPosition"
                            placeholder="Cargo actual"
                            value={currentPosition}
                            onChange={headleCurrentPosition}
                            className="inputsUpdateSection"
                        />
                    </div>
                    <div className="containerInputsUpdateSection">
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsUpdateSection"
                        />
                        <input
                            type="number"
                            name="phone"
                            placeholder="célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsUpdateSection"
                        />
                    </div>
                    <div className="containerInputsEndUpdateSection">
                        <div className="containerSignature">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Firma:
                            </p>
                            <SignatureCanvas
                                ref={sigCanvas}
                                penColor="black"
                                canvasProps={{
                                    className: 'signatureLinkageSection',
                                }}
                            />
                            <div className="containerButtonSignature">
                                <div className="cleaningAndSaveButton" onClick={clearSignature}>
                                    <p className="textCleaningAndSaveButton">
                                        Limpiar
                                    </p>
                                </div>
                                <div className="cleaningAndSaveButton" onClick={saveSignature}>
                                    <p className="textCleaningAndSaveButton">
                                        Guardar
                                    </p>
                                </div>
                            </div>

                            {/* {signature && (
                                <div>
                                    <h3>Tu firma guardada:</h3>
                                    <img src={signature} alt="Firma" className="previewSignature" />
                                </div>
                            )} */}
                        </div>
                    </div>
                    <div className="buttonFormUpdate" onClick={postFormUpdate}>
                        <p className="textFormUpdate">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Update;
